// AddUserModal.js
import React, { useState } from "react";
import "./admin.css";

const AddUserModal = ({ onClose, onAddUser }) => {
  const [newUser, setNewUser] = useState({
    username: "",
    email: "",
    mot_de_passe: "",
    role: "utilisateur",
    date_creation: new Date().toISOString(),
  });

  const handleSave = () => {
    if (!newUser.username || !newUser.email || !newUser.mot_de_passe) {
      alert("Veuillez remplir tous les champs.");
      return;
    }
    onAddUser(newUser); 
  };

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <h2>Ajouter un nouvel utilisateur</h2>

        <label>Nom d'utilisateur</label>
        <input
          type="text"
          value={newUser.username}
          onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
          placeholder="Entrez le nom"
        />

        <label>Email</label>
        <input
          type="email"
          value={newUser.email}
          onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          placeholder="Entrez l'email"
        />

        <label>Mot de passe</label>
        <input
          type="password"
          value={newUser.mot_de_passe}
          onChange={(e) => setNewUser({ ...newUser, mot_de_passe: e.target.value })}
          placeholder="Entrez le mot de passe"
        />

        <label>Rôle</label>
        <select
          value={newUser.role}
          onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
        >
          <option value="admin">Admin</option>
          <option value="utilisateur">Utilisateur</option>
        </select>

        <div className="modalActions">
          <button className="saveButton" onClick={handleSave}>
            Enregistrer
          </button>
          <button className="cancelButton" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
